/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/471-foursquare': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.306 1.408A1.001 1.001 0 0012.5 1H3a1 1 0 00-1 1v12a1.002 1.002 0 00.999 1 1 1 0 00.707-.293L7.413 11h2.586a.999.999 0 00.954-.702l2.5-8a.999.999 0 00-.149-.891zM10.515 5H7a1 1 0 000 2h2.89l-.625 2H7a.997.997 0 00-.707.293L4 11.586V3h7.14l-.625 2z"/>'
  }
})
